import qs from 'qs';
import _ from 'lodash';
import {apiDelete, apiGet, apiPost, apiPut} from "./helper/ApiHelper";
import {ERROR_FETCHING_LIST_TYPES, FETCHING_LIST_TYPES} from "./actions";

export const FETCHING_ACTIVITY_TYPES = 'FETCHING_ACTIVITY_TYPES';
export const ACTIVITY_TYPES_FETCHED = 'ACTIVITY_TYPES_FETCHED';
export const ERROR_FETCHING_ACTIVITY_TYPES = 'ERROR_FETCHING_ACTIVITY_TYPES';

export function fetchActivityTypes(response) {
  return {
    type: ACTIVITY_TYPES_FETCHED,
    activityTypes: response
  }
}

export const handleFetchActivityTypes = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_ACTIVITY_TYPES 
      });
      const response = await apiGet('/v1/user/types/activity_types', session, {}, cancelToken, {
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      })

      dispatch(fetchActivityTypes(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_ACTIVITY_TYPES,
        activityTypes: {
          status: 'error',
          message: 'Error fetching activity types'
        }
      });
    }
  };
}

export const FETCHING_NOTE_TYPES = 'FETCHING_NOTE_TYPES';
export const NOTE_TYPES_FETCHED = 'NOTE_TYPES_FETCHED';
export const ERROR_FETCHING_NOTE_TYPES = 'ERROR_FETCHING_NOTE_TYPES';

export function fetchNoteTypes(response) {
  return {
    type: NOTE_TYPES_FETCHED,
    noteTypes: response
  }
}

export const handleFetchNoteTypes = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_NOTE_TYPES 
      });
      //hack to avoid calling multiple times to note types controller
      const hardcodedDataResponse = {status: 'fetched', note_types: session.note_types}
      dispatch(fetchNoteTypes(hardcodedDataResponse));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_NOTE_TYPES,
        noteTypes: {
          status: 'error',
          message: 'Error fetching note types'
        }
      });
    }
  };
}

export const FETCHING_TYPES_FOR_NOTES = 'FETCHING_TYPES_FOR_NOTES';
export const TYPES_FOR_NOTES_FETCHED = 'TYPES_FOR_NOTES_FETCHED';
export const ERROR_FETCHING_TYPES_FOR_NOTES = 'ERROR_FETCHING_TYPES_FOR_NOTES';

export function fetchMyTypesForNotes(response) {
  return {
    type: TYPES_FOR_NOTES_FETCHED,
    myNoteTypes: response
  }
}

export const handleFetchMyTypesForNotes = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_TYPES_FOR_NOTES 
      });

      const response = await apiGet('/v1/user/types/my_note_types', session, {}, cancelToken)

      dispatch(fetchMyTypesForNotes(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_TYPES_FOR_NOTES,
        myNoteTypes: {
          status: 'error',
          message: 'Error fetching myNoteTypes'
        }
      });
    }
  };
}

export const FETCHING_TYPES_FOR_TASKS = 'FETCHING_TYPES_FOR_TASKS';
export const TYPES_FOR_TASKS_FETCHED = 'TYPES_FOR_TASKS_FETCHED';
export const ERROR_FETCHING_TYPES_FOR_TASKS = 'ERROR_FETCHING_TYPES_FOR_TASKS';

export function fetchMyTypesForTasks(response) {
  return {
    type: TYPES_FOR_TASKS_FETCHED,
    myTaskTypes: response
  }
}

export const handleFetchMyTypesForTasks = (session, cancelToken) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCHING_TYPES_FOR_TASKS 
      });

      const response = await apiGet('/v1/user/types/my_task_types', session,{},  cancelToken)

      dispatch(fetchMyTypesForTasks(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_FETCHING_TYPES_FOR_TASKS,
        myTaskTypes: {
          status: 'error',
          message: 'Error fetching myTaskTypes'
        }
      });
    }
  };
}


///////
export const CREATING_NOTE_TYPE = 'CREATING_NOTE_TYPE';
export const NOTE_TYPE_CREATED = 'NOTE_TYPE_CREATED';
export const ERROR_CREATING_NOTE_TYPE = 'ERROR_CREATING_NOTE_TYPE';

export function createNoteType(response) {
  return {
    type: NOTE_TYPE_CREATED,
    noteType: response
  }
}

export const handleCreateNoteType = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: CREATING_NOTE_TYPE
      });

      const newParams = { ...params, category: 'note' };
      const response = await apiPost('/v1/user/types',   qs.stringify({ type: _.isEmpty(params) ? {} : JSON.stringify(newParams) }), session, cancelToken,{
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      })

      dispatch(createNoteType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_CREATING_NOTE_TYPE,
        noteType: {
          status: 'error',
          message: 'Error creating type'
        }
      });
    }
  };
}

export const UPDATING_NOTE_TYPE = 'UPDATING_NOTE_TYPE';
export const NOTE_TYPE_UPDATED = 'NOTE_TYPE_UPDATED';
export const ERROR_UPDATING_NOTE_TYPE = 'ERROR_UPDATING_NOTE_TYPE';

export function updateNoteType(response) {
  return {
    type: NOTE_TYPE_UPDATED,
    noteType: response
  }
}

export const handleUpdateNoteType = (session, cancelToken, typeId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_NOTE_TYPE
      });
      const response = await apiPut( `/v1/user/types/${typeId}`,  qs.stringify({ type: _.isEmpty(params) ? {} : JSON.stringify(params) }), session, cancelToken,{
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      });

      dispatch(updateNoteType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_NOTE_TYPE,
        noteType: {
          status: 'error',
          message: 'Error updating type'
        }
      });
    }
  };
}

export const DELETING_NOTE_TYPE = 'DELETING_NOTE_TYPE';
export const NOTE_TYPE_DELETED = 'NOTE_TYPE_DELETED';
export const ERROR_DELETING_NOTE_TYPE = 'ERROR_DELETING_NOTE_TYPE';

export function deleteNoteType(response) {
  return {
    type: NOTE_TYPE_DELETED,
    deletedNoteType: response
  }
}

export const handleDeleteNoteType = (session, cancelToken, typeId) => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETING_NOTE_TYPE
      });
      const response = await apiDelete(`/v1/user/types/${typeId}`, session, {}, cancelToken, {
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      });

      dispatch(deleteNoteType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_DELETING_NOTE_TYPE,
        deletedNoteType: {
          status: 'error',
          message: 'Error deleting type'
        }
      });
    }
  };
}

//////////

export const CREATING_TASK_TYPE = 'CREATING_TASK_TYPE';
export const TASK_TYPE_CREATED = 'TASK_TYPE_CREATED';
export const ERROR_CREATING_TASK_TYPE = 'ERROR_CREATING_TASK_TYPE';

export function createTaskType(response) {
  return {
    type: TASK_TYPE_CREATED,
    taskType: response
  }
}

export const handleCreateTaskType = (session, cancelToken, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: CREATING_TASK_TYPE
      });

      const newParams = { ...params, category: 'activity' };
      const response = await apiPost('/v1/user/types', qs.stringify({ type: _.isEmpty(params) ? {} : JSON.stringify(newParams) }), session, cancelToken,{
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      })

      dispatch(createTaskType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_CREATING_TASK_TYPE,
        taskType: {
          status: 'error',
          message: 'Error creating type'
        }
      });
    }
  };
}

export const UPDATING_TASK_TYPE = 'UPDATING_TASK_TYPE';
export const TASK_TYPE_UPDATED = 'TASK_TYPE_UPDATED';
export const ERROR_UPDATING_TASK_TYPE = 'ERROR_UPDATING_TASK_TYPE';

export function updateTaskType(response) {
  return {
    type: TASK_TYPE_UPDATED,
    taskType: response
  }
}

export const handleUpdateTaskType = (session, cancelToken, typeId, params = {}) => {
  return async dispatch => {
    try {
      dispatch({
        type: UPDATING_TASK_TYPE
      });
      const response = await apiPut( `/v1/user/types/${typeId}`,  qs.stringify({ type: _.isEmpty(params) ? {} : JSON.stringify(params) }), session, cancelToken,{
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      });

      dispatch(updateTaskType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_UPDATING_TASK_TYPE,
        taskType: {
          status: 'error',
          message: 'Error updating type'
        }
      });
    }
  };
}

export const DELETING_TASK_TYPE = 'DELETING_TASK_TYPE';
export const TASK_TYPE_DELETED = 'TASK_TYPE_DELETED';
export const ERROR_DELETING_TASK_TYPE = 'ERROR_DELETING_TASK_TYPE';

export function deleteTaskType(response) {
  return {
    type: TASK_TYPE_DELETED,
    deletedTaskType: response
  }
}

export const handleDeleteTaskType = (session, cancelToken, typeId) => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETING_TASK_TYPE
      });

      const response = await apiDelete(`/v1/user/types/${typeId}`, session, {}, cancelToken, {
        'Content-Type': 'multipart/form-data',
        'X-User-Email': session.email,
        'X-User-Token': session.token,
        'X-User-Admin-Log-Token': session.admin_auth_token,
      });
      
      dispatch(deleteTaskType(response.data));
    } catch (e) {
      dispatch({
        type: ERROR_DELETING_TASK_TYPE,
        deletedTaskType: {
          status: 'error',
          message: 'Error deleting type'
        }
      });
    }
  };
}
